var map = {
	"./Total-revenue.png": 720,
	"./alert-outline.svg": 505,
	"./arrow-bottom.svg": 873,
	"./arrow-top.svg": 874,
	"./box.svg": 553,
	"./complete.svg": 721,
	"./dna-report-result-push-notif.png": 875,
	"./dna-report.png": 876,
	"./ehr.svg": 877,
	"./img-placeholder.svg": 713,
	"./kit-box-sold.png": 722,
	"./mapper-processed.png": 878,
	"./mapper-skipped.png": 879,
	"./mdi-archive-refresh-outline.png": 723,
	"./money.svg": 552,
	"./nav-partnership.png": 880,
	"./orders-from-apps.png": 724,
	"./partnership-create-account.png": 725,
	"./partnership-manage-account.png": 726,
	"./pencil-box-outline.svg": 727,
	"./profile.svg": 715,
	"./report-pdf.png": 881,
	"./sent.svg": 551,
	"./success.png": 728,
	"./total-app-users.png": 729,
	"./total-kit-activation.png": 730,
	"./total-reports.png": 716,
	"./warning.svg": 707
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 872;